import { render, staticRenderFns } from "./SalesChartBar.vue?vue&type=template&id=5f323040&"
import script from "./SalesChartBar.vue?vue&type=script&lang=js&"
export * from "./SalesChartBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports